export default {
    container: {
        xl: '1440px',
        md: '740px',
    },
    input: {
        sm: '120px',
        md: '180px',
        lg: '240px',
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2l6ZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi8uLi9hcGV4LW9ubGluZS9jb21wb25lbnQtbGlicmFyeS90aGVtZS9mb3VuZGF0aW9ucy9zaXplcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxlQUFlO0lBQ2IsU0FBUyxFQUFFO1FBQ1QsRUFBRSxFQUFFLFFBQVE7UUFDWixFQUFFLEVBQUUsT0FBTztLQUNaO0lBQ0QsS0FBSyxFQUFFO1FBQ0wsRUFBRSxFQUFFLE9BQU87UUFDWCxFQUFFLEVBQUUsT0FBTztRQUNYLEVBQUUsRUFBRSxPQUFPO0tBQ1o7Q0FDRixDQUFBIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQge1xuICBjb250YWluZXI6IHtcbiAgICB4bDogJzE0NDBweCcsXG4gICAgbWQ6ICc3NDBweCcsXG4gIH0sXG4gIGlucHV0OiB7XG4gICAgc206ICcxMjBweCcsXG4gICAgbWQ6ICcxODBweCcsXG4gICAgbGc6ICcyNDBweCcsXG4gIH1cbn1cbiJdfQ==